import { Form } from 'antd';
import { Rule } from 'antd/lib/form';
import { FC, memo, ReactNode } from 'react';

interface IProps {
    label?: ReactNode;
    name?: string;
    colon?: boolean;
    extra?: ReactNode;
    initialValue?: string;
    labelAlign?: 'left' | 'right';
    required?: boolean;
    tooltip?: ReactNode;
    rules?: Rule[];
    validateStatus?: '' | 'success' | 'warning' | 'error' | 'validating' | undefined;
    help?: string;
    children?: ReactNode;
    className?: string;
}

const FormItemWrap: FC<IProps> = ({
    label,
    name,
    colon = false,
    extra,
    initialValue,
    labelAlign,
    required,
    tooltip,
    rules,
    validateStatus,
    help,
    children,
    className,
}) => {
    return (
        <Form.Item
            label={label}
            name={name}
            colon={colon}
            extra={extra}
            initialValue={initialValue}
            labelAlign={labelAlign}
            required={required}
            tooltip={tooltip}
            rules={rules}
            validateStatus={validateStatus}
            help={help}
            className={className}
        >
            {children}
        </Form.Item>
    );
};

export default memo(FormItemWrap);
